import { useEffect, useState } from 'react';  
import { Card, Checkbox, Col, Divider, Input, Row, Select, Space, Steps, Typography, Pagination, Image, Descriptions, Spin } from 'antd';  
import { listAddons, listAvailableAddons } from '@/apis/addons';
  
const { StepItem } = Steps;  
  
export const SelectAddons = ({props}) => {  
  const [currentStep, setCurrentStep] = useState(0); 
  const [isLoading, setIsLoading] = useState(false);
  const [addons, setAddons] = useState([]);
  const {state, dispatch, id} = props;

  const { Title, Paragraph } = Typography;
  const {Meta} = Card;

  const handleStepChange = (newStep) => {  
    setCurrentStep(newStep);  
  };  

  useEffect(() => {
    const lisAddons = async () => {
      try {
        setIsLoading(true);
        const response = await listAvailableAddons();   
        if("OK" === response.status) {
          const availableAddons = response.value;
          const existAddonsResponse = await listAddons(id);
          if("OK" === response.status) {
            const existAddons = existAddonsResponse.value?.map((item) => item.addon) || [];
            setAddons(availableAddons.filter((item) => !existAddons.some((addon) => addon.id == item.id)));
          } else 
            setAddons(availableAddons);
        }   
        setIsLoading(false);
      } catch (error) {
        setAddons([]);
        setIsLoading(false);
        console.error("get available addons failed:", error);
      }
    };

    lisAddons();
  }, []);

  const onAddonCheckChange = ((checked, addon) => {
    if(checked) {
      dispatch({type : 'SET', payload: [...state, addon]});
    } else {
      dispatch({type : 'SET', payload: state.filter(item => item.id !== addon.id)});
    }
  })

  const builtInCard = (addon, index) => {
    return (
      <Card
        hoverable
        align="start"
        style={{
          width: 300,
        }}
        extra={
          <Checkbox checked= {state.find(selectedAddon => selectedAddon.id == addon.id)} onChange={(e) => onAddonCheckChange(e.target.checked, addon)}/>
        }
        title = {
          <img style={{width: '80px', padding: '8px'}} src="../../../../vitria.svg"/>
        }
        onClick={() => onAddonCheckChange(true, addon)}
      >
        <Meta title={addon.name} description={addon.desc}/>
        <Title level={5} style={{paddingTop: '50px'}}>Category</Title>
        <Paragraph><strong>{addon.category}</strong></Paragraph>
      </Card>
    );
  }

  const marketCard = () => {
    return (
      <Card style={{ display: 'flex', flexDirection: 'column', borderRadius: '8px', overflow: 'hidden', width: '100%' }}>
      <Row>
            {/* 左侧图片 */}
            <Col span={2}>
              <Image
                src="../../../../vitria.svg"
                alt="Placeholder"
                preview={false}
                style={{height: '5vh', width: '5vh' }}
              />
            </Col>

            <Col span={22}>
              <div style={{ position: 'absolute', right: '16px' }}>
                <Checkbox/>
              </div>
              <Title level={4}>Cisco Cloud Obserivibility Collector</Title>
              <Paragraph>Collectors to instrument EKS to gain insights on clusters, namespace, workloads, pods & etc.</Paragraph>
              <br/>
              <Space direction="vertical" style={{ width: '100%' }}> 
                <Row gutter={[16, 8]} justify="space-between">  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      <Col><span>Catetory</span><br /><span><strong>test</strong></span></Col>  
                    </Row>  
                  </Col>  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      <Col><span>Listed By</span><br /><span><strong>test</strong></span></Col>  
                    </Row>  
                  </Col>  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      <Col><span>Supported Version</span><br /><span><strong>test</strong></span></Col>  
                    </Row>  
                  </Col>  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      <Col><span>Pricing starting at...</span><br /><span><strong>test</strong></span></Col>  
                    </Row>  
                  </Col>
                </Row>  
              </Space>
            </Col>
          </Row>     
    </Card>
    );
  }
  
  return (  
    <div>
      <Title level={2} >Select add-ons</Title>
      <Paragraph>Review the add-ons from multiple categories, then select add-ons to enhance your AIOps.</Paragraph>
      <Divider style={{margin: '5px'}}/>
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: 'flex',
        }}
      >
        <Title level={4}>Vitria Add-ons ({addons.length})</Title>
        {isLoading && <Spin size="large" />}
        <Row gutter={[24,24]}>
          {
            addons.map((addon, index) => (
              <Col>
                {builtInCard(addon, index)}
              </Col>
            ))
          } 
        </Row>
      </Space>
    </div>
  );  
};  